import { IntlFormatters } from 'react-intl'
import * as yup from 'yup'

export const frisoOnboardingSchema = (f: IntlFormatters['formatMessage']) =>
  yup.object().shape({
    phone: yup
      .string()
      .transform((currentValue) => currentValue.replace('+84', '0'))
      .required(f({ id: 'onboarding.friso.updatePhone.error' }))
      .length(10, 'Số điện thoại không hợp lệ')
      .default(''),
    dob: yup
      .string()
      .required(f({ id: 'onboarding.friso.errorMessage.requiredDob' }))
      .default(''),
    name: yup
      .string()
      .required(f({ id: 'onboarding.friso.errorMessage.requiredFirstName' })),
    email: yup
      .string()
      .required(f({ id: 'onboarding.friso.errorMessage.requiredEmail' }))
      .email(f({ id: 'onboarding.friso.errorMessage.invalidEmail' }))
      .default(''),
    address: yup.mixed().required(f({ id: 'onboarding.friso.address.error' })),
    term: yup.bool().oneOf([true], f({ id: 'onboarding.friso.term.error' })),
  })
